// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Brand_imageWrapper__pKF+D","image":"Brand_image__cyDZo","description":"Brand_description__9uOd2"};